var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PlanEdit',_vm._g(_vm._b({on:{"go-back":_vm.goListPage}},'PlanEdit',{ chart: _vm.chart, template: _vm.template, cols: _vm.cols, rows: _vm.rows },false),{
      saveTemplate: _vm.saveTemplate,
      editTaskGroup: _vm.editTaskGroup,
      newTaskGroup: _vm.newTaskGroup,
      editTask: _vm.editTask,
      newTask: _vm.newTask,
      change: _vm.change,
      submit: _vm.submit,
      cancel: _vm.cancel,
      remove: _vm.remove,
      resize: _vm.resize,
      goPrev: _vm.goPrev,
      goNext: _vm.goNext,
      sort: _vm.sort
    })),_c('PlanTaskGroupEditModal',{ref:"editGroup",attrs:{"options":_vm.taskTypeOptions},on:{"submit":_vm.saveTaskGroup,"delete":_vm.deleteTaskGroup}}),_c('PlanTaskEditModal',{ref:"editTask",on:{"submit":_vm.saveTask,"delete":_vm.deleteTask}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }